pageId = 'teams-dashboards-projects-statistics-index'

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  initStatisticThumbs($page)
  initSortables()

initStatisticThumbs = ($scope) ->
  $scope.find('.statistic-thumbnail.loading-thumb').each (i, thumbnail) ->
    $thumbnail = $(thumbnail)

    $.ajax
      url: $thumbnail.data('thumb-url')
      method: 'GET'
      dataType: 'json'
    .done (data) ->
      $thumbnail
        .removeClass('loading-thumb')
        .find('.statistic-thumbnail-image')
          .html(data.html)

initSortables = ->
  $sortable = $('.sortable')
  return unless $sortable.length

  $sortable.sortable
    helper: 'clone'
    scrollSensitivity: 20
    cursor: 'move'
    distance: 20
    items: '> .sortable-item'
    stop: (e, ui) ->
      $.ajax
        method: 'post'
        url: ui.item.data('sort-url')
        data:
          prev_sortable_id: ui.item.prev('.sortable-item').data('id')
          next_sortable_id: ui.item.next('.sortable-item').data('id')
